import { v4 as uuidv4 } from 'uuid';
import reduce from 'image-blob-reduce';
export class PicturesService {
    constructor(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async findById(pictureId) {
        const response = await fetch(`${this.serviceUrl}/picture/${pictureId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener la imagen.');
        }
        return response.json();
    }
    async findByLabels(labels) {
        const query = new URLSearchParams();
        labels.forEach(label => {
            query.append('filters[label]', label);
        });
        const response = await fetch(`${this.serviceUrl}/pictures?${query}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener las imágenes.');
        }
        return response.json();
    }
    async uploadPicture(file, labels, meta) {
        const pictureId = uuidv4();
        const formData = new FormData();
        formData.set('pictureId', pictureId);
        formData.set('pictureLabels', labels.join(','));
        if (meta) {
            for (const key of Object.keys(meta)) {
                formData.set(`pictureMeta[${key}]`, meta[key]);
            }
        }
        const resized = await this.resize(file);
        formData.set('file', resized);
        const response = await fetch(`${this.serviceUrl}/picture`, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al enviar la imagen.');
        }
        return pictureId;
    }
    resize(file) {
        const reducer = reduce();
        return reducer.toBlob(file, {
            max: 2000,
        });
    }
}
